export default {"src":"/_next/static/media/batman.3aa6f953.svg","height":135,"width":212};